import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { setUpUUIDAction } from 'root-redux/actions/user'
import {
  selectCurrentVariantCohort,
  selectGiaApiKeys,
  selectLanguage,
} from 'root-redux/selects/common'
import { TAppDispatch } from 'root-redux/store/store'

import { getQueryParamsFromSearchString } from 'helpers/getQueryParamsFromSearchString'

export const useSetUuid = () => {
  const dispatch: TAppDispatch = useDispatch()
  const cohort = useSelector(selectCurrentVariantCohort)
  const giaApiKeys = useSelector(selectGiaApiKeys)
  const language = useSelector(selectLanguage)

  useEffect(() => {
    const searchParams = new URLSearchParams(document.location.search)
    const uuidFromUrl = searchParams.get('uuid')
    const utmTags = getQueryParamsFromSearchString(document.location.search)

    if (cohort && giaApiKeys && language) {
      dispatch(
        setUpUUIDAction({
          cohort,
          utmTags,
          giaApiKey: giaApiKeys[language],
          uuid: uuidFromUrl,
          language,
        }),
      )
    }
  }, [dispatch, cohort, giaApiKeys, language])
}
